import {
    inject,
    Injectable
} from '@angular/core';

import { filter } from 'rxjs';

import {
    EntityManagerService,
    StorageManagerService
} from 'src/app/core';

import {
    Printers,
    Sales
} from 'tilby-models';

@Injectable({
    providedIn: 'root'
})
export class KDSManager {
    private entityManager = inject(EntityManagerService);

    constructor(
    ) {
        StorageManagerService.storageUpdates$.pipe(
            filter((data) => data.entityName == 'sales'),
        ).subscribe(async (data) => {
            if (
                data.action == 'DELETED' && 
                data.entity &&
                'deleted' in data.entity &&
                'uuid' in data.entity &&
                data.entity?.deleted
            ) {
                const KDSToSend = await this.entityManager.printers.fetchCollectionOffline({ type: 'kds' }) as Printers[];

                for (const kds of KDSToSend) {
                    try {
                        await this.deleteOrder(kds, data.entity.uuid!);
                    } catch (err) { }
                }
            }
        });
    }

    public async deleteOrder(kds: Printers, orderUuid: string): Promise<void> {
        switch (kds.driver) {
            case 'http':
            default:
                await fetch(`http://${kds.ip_address}/orders/${orderUuid}`, {
                    method: 'DELETE',
                    signal: AbortSignal.timeout(10000)
                });
                break;
        }
    }

    public async sendOrders(kds: Printers, sales: Sales[]): Promise<void> {
        switch (kds.driver) {
            case 'http':
            default:
                await fetch(`http://${kds.ip_address}/orders`, {
                    method: 'POST',
                    body: JSON.stringify(sales),
                    signal: AbortSignal.timeout(10000)
                });
                break;
        }
    }

    /**
     * Send all open orders to KDS
     */
    public async init() {
        const kdsList = await this.entityManager.printers.fetchCollectionOffline({ type: 'kds' });
        const sales = await this.entityManager.sales.fetchCollectionOffline({ status: 'open' });

        for (const kds of kdsList) {
            try {
                await this.sendOrders(kds, sales);
            } catch (err) { }
        }
    }
}